import o from"@mui/material/Divider";import{jsx as p}from"react/jsx-runtime";var r=({isAbsolute:e,...i})=>p(o,{...i,absolute:e});export{r as a};
